import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CalendarObject } from '../pages/Dashboard/hooks/useCalendarDates'
import { BookingTerm } from '../firebase/types-bookings'
import { RootState } from './store'

export type CurrentTerm = {
    term: BookingTerm
    weekNo: number
}

interface ICalendarSlice {
    calendar?: CalendarObject
    currentTerm?: CurrentTerm
}
const initialState: ICalendarSlice = {}

export const calenderSlice = createSlice({
    name: 'calendar',
    initialState: initialState,
    reducers: {
        setCalendar: (state, action: PayloadAction<CalendarObject>) => {
            state.calendar = action.payload
        },
        setCurrentTerm: (state, action: PayloadAction<CurrentTerm>) => {
            state.currentTerm = action.payload
        },
    },
})

export const selectCalendar = (state: RootState) => state.calendar.calendar

export const selectCalendarWorkingWeeks = (state: RootState) =>
    state.calendar.calendar?.weeks

export const selectCalendarRange = (state: RootState) =>
    state.calendar.calendar?.range
export const selectCalendarHolidays = (state: RootState) =>
    state.calendar.calendar?.publicHolidays
export const selectCalendarIndex = (state: RootState) =>
state.calendar.calendar?.dateIndex

export const makeSelectDateIndexByDate = () =>
    createSelector(
        [
            (state: RootState) => state.calendar.calendar?.dateIndex,
            (_: RootState, date: string) => date,
        ],
        (dateIndex, date) => dateIndex?.[date]
    )

export const { setCalendar, setCurrentTerm } = calenderSlice.actions
export default calenderSlice.reducer
